module.exports = __webpack_public_path__ + "static/img/son5_active.6f772d3b.png";